import useSWR from 'swr'
import { queryToParams } from './logic/query'
import type { LockDetail, LockPage, LockQuery, TokenLocks } from './types'
import type { LockType } from './config'
import type { WalletAssets } from './server/wallet'

/** a 404 (no such lock or token), a 400 or a 429 is an answer, not a failure to retry */
const noRetry = (err: Error, _key: string, _config: unknown, revalidate: (o: { retryCount: number }) => void, { retryCount }: { retryCount: number }) => {
  if (['404', '400', '429'].includes(err.message) || retryCount >= 3) return
  setTimeout(() => revalidate({ retryCount }), 2000 * 2 ** retryCount)
}
const fetcher = (url: string) => fetch(url).then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
const base = { revalidateOnFocus: false, onErrorRetry: noRetry }

export const lockPageUrl = (q: LockQuery) => `/api/locks?${new URLSearchParams(queryToParams(q)).toString()}`
export const useLockPage = (q: LockQuery | null) => useSWR<LockPage>(q ? lockPageUrl(q) : null, fetcher, { ...base, refreshInterval: 60_000, keepPreviousData: true })
export const useLockDetail = (type?: LockType, id?: number | string, fallback?: LockDetail) =>
  useSWR<LockDetail>(type && id !== undefined ? `/api/locks/${type}/${id}` : null, fetcher, { ...base, refreshInterval: 60_000, fallbackData: fallback })
export const useTokenLocks = (address?: string) => useSWR<TokenLocks>(address ? `/api/locks/token/${address}` : null, fetcher, { ...base, refreshInterval: 60_000 })
export const useWalletAssets = (owner?: string) => useSWR<WalletAssets>(owner ? `/api/locks/wallet?owner=${owner}` : null, fetcher, { ...base, refreshInterval: 30_000 })
